import { Modal } from "antd";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import 'github-markdown-css/github-markdown.css';

export function ChangelogDialog({ content, onClose }: { content: string | null; onClose: () => void }) {
  if (!content) return null;

  return (
    <Modal
      title="What's New"
      centered
      closable={false}
      maskClosable={false}
      open={true}
      onOk={onClose}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div className="markdown-body">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {content}
        </ReactMarkdown>
      </div>
    </Modal>
  );
}
